import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import Popup from 'Components/Popup'
import React from 'react'
import styles from './styles'

const ConfirmationPopup = ({
  classes,
  onCancel,
  isOpen,
  onConfirm,
  isInProgress,
  body = 'Please confirm if you want to delete selected data. The action can not be undone.',
  title = 'Confirm Delete',
}) => {
  if (!isOpen) {
    return null
  }

  return (
    <Popup
      title={title}
      onCancel={onCancel}
      canBeClose={!isInProgress}
      modalClassName={classes.confirmModal}
      body={
        <div>
          <div className={classes.infoBlock}>{body}</div>
        </div>
      }
      footer={
        <div>
          <Button
            className={cn(classes.button, classes.filledButton)}
            onClick={onConfirm}
            variant="contained"
            disabled={isInProgress}
          >
            {isInProgress ? <CircularProgress size={20} /> : null} Confirm
          </Button>
          <Button
            className={classes.button}
            variant="outlined"
            onClick={onCancel}
            disabled={isInProgress}
          >
            Cancel
          </Button>
        </div>
      }
    />
  )
}

export default withStyles(styles)(ConfirmationPopup)
